'use client';

import Image from 'next/image';
import Link from 'next/link';
import type { LucideIcon } from 'lucide-react';

export interface HeaderProps {
    title: string;
    subTitle: string;
    url?: string;
    icon?: LucideIcon;
}
export default function Header({ title, subTitle, url, icon: Icon }: HeaderProps) {
    return (
        <div className="flex flex-shrink-0 w-full pb-4">
            <div className="flex flex-col lg:flex-row flex-grow items-start lg:justify-start lg:items-end font-corp font-bold text-12px lg:text-15px text-black tracking-widest ml-1">
                <div className="flex items-center gap-2 pl-0 lg:pl-2">
                    {Icon && <Icon size={20} strokeWidth={1.5} className="text-black flex-shrink-0" />}
                    <div className="font-montserrat font-black text-base lg:text-28px text-black tracking-widest">
                        {title}.
                    </div>
                </div>
                <div className="translate-y-[1px] lg:translate-y-[4px]">{subTitle}</div>
            </div>
            <div className="flex justify-end items-center w-8 lg:w-20">
                {url && (
                    <Link href={url as string} target="_blank" rel="noopener noreferrer" className="underline">
                        <Image src="/images/common/question.svg" alt="support" width={25} height={25} quality={100} />
                    </Link>
                )}
            </div>
        </div>
    );
}
